import React from "react";

interface TextareaProps
  extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {
  key?: string;
  label?: string;
  name?: string;
  placeholder?: string;
  value?: any;
  onChange?: (e: React.ChangeEvent<HTMLTextAreaElement>) => void;
  error?: boolean;
  helperText?: string;
  rows?: number;
  required?: boolean;
  optional?: boolean;
}

const Textarea: React.FC<TextareaProps> = ({
  key = "",
  label,
  name,
  placeholder,
  value,
  onChange,
  error,
  helperText,
  rows = 4,
  required = false,
  optional = false,
}) => {
  return (
    <div key={key} className="flex flex-col items-start space-y-1">
      {label && (
        <label className="text-sm font-medium text-gray-700 dark:text-gray-300">
          {label} {optional && <span>(optional)</span>}{" "}
          {required && <span className="text-red-600">*</span>}
        </label>
      )}

      <textarea
        name={name}
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        className={`w-full rounded-lg p-3 h-32 outline-none placeholder:text-sm text-sm bg-white text-gray-900 placeholder-gray-400 dark:bg-gray-800 dark:text-gray-100 dark:placeholder-gray-500 border focus:ring-2 ${
          error
            ? "border-red-500 focus:ring-red-500"
            : "border-gray-300 focus:ring-indigo-500 dark:border-gray-700 dark:focus:ring-primary-500"
        }`}
        rows={rows}
      />

      {helperText && (
        <span
          className={`text-xs ${
            error ? "text-red-500" : "text-gray-500 dark:text-gray-400"
          }`}
        >
          {helperText}
        </span>
      )}
    </div>
  );
};

export default Textarea;
